import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import {
  Button,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Paper,
  Grid,
  DialogActions
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
// import RfsStyles from '';
import RfsStyles from '../rfs/rfs.module.css';
import commonStyles from '../common/common.module.css';
import MaterialTable from 'material-table';
import Zoom from '@material-ui/core/Zoom';
import modalStyles from './forwarderHeader.module.css';
import AwbsDataTable from '../../models/AwbsDataTable';
import Awb from '../../models/Awb';

const styles = (theme: Theme) =>
  createStyles({
    rowContainer: {
      paddingLeft: 20,
      paddingRight: 20,
    },
    button: {
      width: '100%',
      height: '34px',
      textTransform: 'none',
    },
    warning: {
        color: 'red'
    },
    materialIcon: {
      margin: '10px 3px 0',
      fontSize: 20,
      '&:hover': {
        cursor: 'pointer',
      },
    },
  });

interface ConfirmAwbProps {
  classes: any;
  modalOpen: boolean;
  handleClose: (type: string) => void;
  awbText: string;
  handleChangeText: Function;
  proceed: Function;
}

const confirmAwb = (props: ConfirmAwbProps) => {
  const { classes } = props;

  return (
    <Dialog
      open={props.modalOpen}
      onClose={() => props.handleClose('confirm')}
      aria-labelledby='form-dialog-title'
      maxWidth={'sm'}
      fullWidth={true}
      TransitionComponent={Zoom}
      transitionDuration={500}>
      <DialogTitle id='form-dialog-title'>
        <div className={RfsStyles.dialogTitle}>
          <span className={RfsStyles.name}>Reconfirm AWB Number</span>
          <IconButton
            aria-label='Close'
            className={RfsStyles.close}
            onClick={() => props.handleClose('confirm')}>
            <CloseIcon color='primary' />
          </IconButton>
        </div>
        <hr />
      </DialogTitle>
      <DialogContent>
        <div className= {`${ commonStyles.wrapper } ${ commonStyles.fvMiddle }`}>
          <div>
            <div className={ commonStyles.hInputLabelWrapper }>           
              <p className={ modalStyles.pcsWgh }>Enter Airwaybill Number:</p>
              <TextField
                id="awb"
                // className={ classNameValPcs }
                value={ props.awbText}
                onChange={ (e: any) => props.handleChangeText(e) }
                // onBlur={ props.onValidationPcs } 
                // error={ !props.awb.pieces || isNaN(+props.awb.pieces) || +props.awb.pieces <= 0 }
                // helperText={ (!props.awb.pieces || isNaN(+props.awb.pieces) || +props.awb.pieces <= 0) ? 'add AWB pieces' : '' }
                // InputProps={{ className: classes.inputTextField, disableUnderline: !allowedAwbUpdateAction  }}
                />
            </div>
          </div>
          <div className={`${ commonStyles.mlauto }`}>
            <Button
              className={classes.submitBtn}
              variant="contained"
              color="primary"
              onClick={() => props.proceed('step2')}
            >
              Submit
            </Button>
          </div>
        </div>
       
      </DialogContent>
      <DialogActions>

      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(confirmAwb);
